<template>
  <el-dialog
    title="反馈"
    :visible.sync="score_dialogVisible"
    width="600px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="addressWrap">
      <!-- <div class="custom_title mb20">
        <div class="icon_title">
          <b>反馈</b>
        </div>
      </div>-->
      <el-card class="box-card">
        <el-form :model="form" ref="formRef" :rules="rules" label-width="86px">
          <el-row>
            <el-col>
              <el-form-item label="评价">
                <el-radio-group v-model="form.score">
                  <el-radio :label="1">非常满意</el-radio>
                  <el-radio :label="2">满意</el-radio>
                  <el-radio :label="3">不满意</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="原因" :prop="form.score==3?'content':' '">
                <el-input
                  type="textarea"
                  v-model="form.content"
                  :autosize="{ minRows: 5, maxRows: 10 }"
                  maxlength="500"
                  show-word-limit
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-card>
    </div>
    <div style="text-align:center;" class="mt20">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>
  <script>
// import { eveluateContrac } from "@/api/user/user";

export default {
  name: "address_dialog",
  props: {
    score_dialogVisible: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: {
        score: "",
        content: ""
      },
      rules:{
        content: [
          { required: true, message: "请选择发票类型", trigger: "change" }
        ],
      }
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      this.$emit("update:score_dialogVisible", false);
    },
    onSubmit() {
      //   eveluateContrac({
      //     id: this.id,
      //     evaluation: {
      //       ...this.form
      //     }
      //   }).then(res => {
      //     if (res.status == 200) {
      //       this.$message({
      //         message: "评价成功",
      //         type: "success"
      //       });
      //       this.$emit("update:score_dialogVisible", false);
      //       this.$emit("refresh");
      //     }
      //   });
    }
  }
};
</script>
  <style lang="less" scoped>
/deep/ .el-dialog {
  .el-dialog__header {
    text-align: left;
    // border-bottom: 1px solid #000;
    background-color: #f8f8f8;
  }

  .el-dialog__body {
    .custom_title {
      background-color: #f1f1f1;
      height: 60px;
      font-size: 16px;

      .icon_title {
        height: 100%;
        display: flex;
        align-items: center;
        text-indent: 20px;

        // &::before {
        //     content: "";
        //     background: #006fb3;
        //     display: inline-block;
        //     width: 5px;
        //     height: 40px;
        //     position: relative;
        //     margin-right: 8px;
        //     left: 10px;
        // }
      }
    }

    .el-table {
      .el-table__header {
        th {
          background-color: #f2f2f2;
        }
      }
    }

    .addressWrap {
      // margin: 30px 60px;
      max-height: 550px;
      overflow-y: auto;
    }

    .areaSelect > .el-select {
      width: 33.3%;
    }
  }
}
/deep/ .labelWidth {
  width: 15%;
}
</style>